export const validaPreenchimentoCampo = (campo, mensagem, funcionAlert) => {
    if (campo === undefined || campo === null || campo === '') {
        funcionAlert(mensagem, "warning")
        return false
    }
    return true
}